import React from "react";
import styled from "styled-components";
import { colors } from "../../../../utils/theme";
import { useNavigate } from "react-router-dom";

const Container = styled.div`
  width: 100%;
  .form {
    border-bottom: 1px solid #00000029;
    padding: 1rem 0;
    width: 95%;
    margin: 0 auto;
  }
`;

const ContainerFormInfo = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
  padding-bottom: 2rem ;
`;
const FormInputInfo = styled.div`
  width: 25%;
  display: flex;
  gap: 20px;
  flex-direction: column;

  @media (max-width: 1440px) {
    width: 30%;
  }
  @media (max-width: 768px) {
    width: 45%;
  }
  @media (max-width: 500px) {
    width: 90%;
  }

  label {
    width: 100%;
    color: ${colors.third};
    font-weight: 600;
    @media (max-width: 1024px) {
      text-align: start;
    }
  }

  input {
    width: 80%;
    height: 40px;
    border: 1px solid #d9d9d9;
    padding-left: 10px;
    color: ${colors.fifth};
    @media (max-width: 500px) {
      width: 100%;
    }
    &::placeholder {
      color: ${colors.fifth};
    }
  }
`;
const SessionFisio = ({sesionFisio}) => {

  const handleInputChange = (newValue) => {
    console.log("");
  };

  if (!sesionFisio) {
    // Muestra un mensaje de carga o redirige
    return <div>Cargando datos del paciente...</div>;
    // O puedes redirigir a una página para seleccionar/obtener datos del paciente nuevamente
  }

  return (
    <div>
      <ContainerFormInfo>
        <FormInputInfo>
          <label>SESIÓN PROXIMA No.</label>
          <input
            type="text"
            value={sesionFisio.sesionProxima}
            onChange={(e) => handleInputChange(e.target.value)}
          />
        </FormInputInfo>

        <FormInputInfo>
          <label>SES. PROGRAMABLES</label>
          <input
            type="text"
            value={sesionFisio.sesionProgramable}
            onChange={(e) => handleInputChange(e.target.value)}
          />
        </FormInputInfo>
        <FormInputInfo>
          <label>FISIOTERAPEUTA</label>
          <input
            type="text"
            value={sesionFisio.fisio}
            onChange={(e) => handleInputChange(e.target.value)}
          />
        </FormInputInfo>

      </ContainerFormInfo>
    </div>
  );
};

export default SessionFisio;
